import React from 'react';
import { RuleStepData } from 'Pages/Build/Detections/CorrelationRules/utils';
import { Handle, NodeProps, Position } from 'reactflow';
import StepNodeV3, {
  StepNodeData,
} from 'Pages/Build/Detections/CorrelationRules/StepNode/StepNodeV3';
import { Box, Flex, Icon, Text } from 'pounceV2';
import { useTheme } from '@mui/material';
import { getFlowChartColors, GROUP_NODE_WIDTH_PX } from './constantsV3';

export interface GroupNodeData {
  stepList: Array<RuleStepData & { error?: string }>; // all of the Rules in the group from the YAML
  showHandles?: boolean;
  minMatchCount: number;
}

const GroupNodeV3 = ({ data: nodeData }: NodeProps<GroupNodeData>) => {
  const theme = useTheme();
  const FLOW_CHART_COLORS = getFlowChartColors(theme.palette.tokens);
  const minMatchCountText =
    nodeData.minMatchCount > 0 ? `(match at least ${nodeData.minMatchCount})` : '';
  return (
    <>
      <Flex
        backgroundColor={FLOW_CHART_COLORS.GROUP.BACKGROUND}
        border="2px solid"
        borderRadius="xlarge"
        borderColor={FLOW_CHART_COLORS.GROUP.BORDER}
        width="fit-content"
        padding={1}
        ml={3}
        position="relative"
        top={-7}
        gap={2}
        align="center"
        sx={{
          zIndex: 1,
          backdropFilter: 'blur(12px)',
        }}
      >
        <Box backgroundColor={FLOW_CHART_COLORS.GROUP.BORDER} p={1} borderRadius="large">
          <Icon size="small" m="auto" display="block" type="combine" />
        </Box>
        <Text as="span" variant="body/sm" color={FLOW_CHART_COLORS.SECONDARY_TEXT}>
          GROUP {minMatchCountText}
        </Text>
      </Flex>
      <Box
        border="2px solid"
        borderRadius="xlarge"
        borderColor={FLOW_CHART_COLORS.GROUP.BORDER}
        width={GROUP_NODE_WIDTH_PX}
        pt={5}
        pb={2}
        mt={-5}
        sx={{
          backdropFilter: 'blur(12px)',
        }}
      >
        <Flex direction="column" gap={4} align="center">
          {nodeData.stepList.map(({ error, ...step }) => {
            const stepNodeData: NodeProps<StepNodeData> = {
              data: { showHandles: false, stepData: step, error },
            } as NodeProps<StepNodeData>;
            return (
              <Box key={step.RuleID}>
                <StepNodeV3 {...stepNodeData} />
              </Box>
            );
          })}
        </Flex>
        {nodeData.showHandles ? (
          <Handle
            type="source"
            position={Position.Bottom}
            isConnectable={false}
            style={{
              border: `1px solid ${FLOW_CHART_COLORS.TRANSITION.BORDER}`,
              backgroundColor: FLOW_CHART_COLORS.TRANSITION.BORDER,
              width: '8px',
              height: '8px',
            }}
          />
        ) : null}
      </Box>
    </>
  );
};

export default GroupNodeV3;
